// Color Tokens
export const colors = {
    // Primary
    primary: {
        50: '#eff6ff',
        100: '#dbeafe',
        500: '#2563eb',
        600: '#1e40af',
        700: '#1d4ed8',
    },
    // Grays - adjusted for better contrast
    gray: {
        50: '#f5f5f5', // Slightly darker for better contrast with white cards
        100: '#f0f0f0', // Adjusted for contrast hierarchy
        200: '#e5e7eb',
        300: '#d1d5db',
        400: '#9ca3af',
        500: '#6b7280',
        600: '#666666', // Slightly adjusted for text readability
        700: '#374151',
        800: '#1f2937',
        900: '#1a1a1a',
    },
    // Status
    success: {
        light: '#dcfce7',
        DEFAULT: '#10b981',
        dark: '#166534',
    },
    error: {
        light: '#fee2e2',
        DEFAULT: '#dc2626',
        dark: '#991b1b',
    },
    warning: {
        light: '#FFF3CD',
        DEFAULT: '#f59e0b',
        dark: '#92400e',
    },
    white: '#ffffff',
    black: '#000000',
};
// Spacing Scale (4px base)
export const spacing = {
    0: '0px',
    1: '4px',
    2: '8px',
    3: '12px',
    4: '16px',
    5: '20px',
    6: '24px',
    8: '32px',
    10: '40px',
    12: '48px',
};
// Typography
export const typography = {
    // Modern system font stack
    fontFamily: {
        sans: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
        mono: 'ui-monospace, SFMono-Regular, "SF Mono", Menlo, Consolas, monospace',
    },
    fontSize: {
        xs: '11px',
        sm: '12px',
        base: '14px',
        md: '16px',
        lg: '18px',
        xl: '20px',
        '2xl': '24px',
        '3xl': '32px',
    },
    fontWeight: {
        normal: '400',
        medium: '500',
        semibold: '600',
        bold: '700',
    },
    // Line heights for better readability
    lineHeight: {
        tight: '1.25',
        normal: '1.5',
        relaxed: '1.75',
    },
};
// Border Radius
export const radius = {
    sm: '4px',
    md: '6px',
    lg: '8px',
    xl: '12px',
    full: '9999px',
};
// Shadows
export const shadows = {
    sm: '0 1px 2px rgba(0, 0, 0, 0.05)',
    md: '0 1px 3px rgba(0, 0, 0, 0.1)',
    lg: '0 4px 6px rgba(0, 0, 0, 0.1)',
};
//# sourceMappingURL=tokens.js.map